import baseAPI from '@/api/base';
import { EditLeaveType, GetLeaveType, RegisterLeaveType } from '@/dtos/leave_type.dto';
import {
  DELETE_LEAVE_TYPE_URL,
  EDIT_LEAVE_TYPE_URL,
  GET_LEAVE_TYPE_URL,
  REGISTER_LEAVE_TYPE_URL,
  TOGGLE_LEAVE_TYPE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class LeaveType {
  static getLeaveTypes = async (getLeaveType: GetLeaveType): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_LEAVE_TYPE_URL, {
      params: getLeaveType,
    });
    console.log('response', response);
    return response;
  };

  static registerLeaveType = async (
    registerLeaveType: RegisterLeaveType
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_LEAVE_TYPE_URL, {
      ...registerLeaveType,
    });
    console.log('response', response);
    return response;
  };

  static editLeaveType = async (editLeaveType: EditLeaveType): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_LEAVE_TYPE_URL, {
      ...editLeaveType,
    });
    return response;
  };

  static toggleLeaveTypeIsActive = async (
    editLeaveType: EditLeaveType
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_LEAVE_TYPE_IS_ACTIVE_URL,
      {
        ...editLeaveType,
      }
    );
    return response;
  };

  static deleteLeaveType = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_LEAVE_TYPE_URL}/${userId}`
    );
    return response;
  };
}

export default LeaveType;
